@if(icon){
<div class="d-flex">
  <svg class="icon" [ngClass]="classes">
    <use
      [attr.xlink:href]="
        '../../assets/media/icons/customized/custom-icon-libs.svg#' + icon
      "
    ></use>
  </svg>
</div>
}
